module.exports = __webpack_public_path__ + "img/faceberry_brightness.3d4f1ecf.png";